import { stateRef } from '../../framework/store'
import { RERENDER_EVENT, setValuesInternal } from '../../framework/actions'
import { generateNavActionExposes } from './routes'
import { __info } from '../../init/debug'
import { useGlobalEventListener } from './appEffects'

export const forceRender = (initedMicroApps = stateRef.current.initedMicroApps) => {
  if (!initedMicroApps?.length) {
    console.error('micro-apps are empty or not provided for forceRerender')
    return // ignore if not provide micro-apps
  }
  const values = generateNavActionExposes(initedMicroApps)
  if (initedMicroApps !== stateRef.current.initedMicroApps) {
    values.initedMicroApps = initedMicroApps
  }
  __info('merged left navigation and actions', values.leftMainNavigation, values.leftMainActions)
  setValuesInternal(values)
}

const forceRerender = () => {
  forceRender()
}

export const useRerender = () => {
  useGlobalEventListener(RERENDER_EVENT, forceRerender)
}
